var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EA9F35",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8213 42.6667H41.4749C43.008 42.6667 44.2274 41.9682 45.3224 40.9915C48.1038 38.5102 41.5653 36.0001 39.3332 36.0001M36.6665 22.7584C36.9693 22.6984 37.2837 22.6667 37.6062 22.6667C40.0328 22.6667 41.9998 24.4576 41.9998 26.6667C41.9998 28.8759 40.0328 30.6667 37.6062 30.6667C37.2837 30.6667 36.9693 30.6351 36.6665 30.575",
    stroke: "#DD7804",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9751 37.4816C20.4031 38.324 16.2815 40.0441 18.7918 42.1965C20.0181 43.248 21.3839 44 23.101 44H32.8991C34.6161 44 35.9819 43.248 37.2081 42.1965C39.7185 40.0441 35.5969 38.324 34.0249 37.4816C30.3387 35.5061 25.6613 35.5061 21.9751 37.4816Z",
    stroke: "#DD7804",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3332 26.0001C33.3332 28.9456 30.9453 31.3334 27.9998 31.3334C25.0543 31.3334 22.6665 28.9456 22.6665 26.0001C22.6665 23.0546 25.0543 20.6667 27.9998 20.6667C30.9453 20.6667 33.3332 23.0546 33.3332 26.0001Z",
    stroke: "#DD7804",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUsers);
export default __webpack_public_path__ + "static/media/active-users.789584afce957de84c4827207e924f9f.svg";
export { ForwardRef as ReactComponent };